export default __webpack_public_path__ + "static/media/screen_facebook_8.9c6ec0cc.png";